import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ColorPickerModule } from "ngx-color-picker";
import { TyaColorPickerComponent } from "./tya-color-picker.component";
import { NbInputModule } from "@nebular/theme";

@NgModule({
  declarations: [TyaColorPickerComponent],
  imports: [FormsModule, CommonModule, ColorPickerModule, NbInputModule],
  exports: [TyaColorPickerComponent],
})
export class TyaColorPickerModule {}
